module.exports = __webpack_public_path__ + "static/media/job5.3dc373a0.jpg";